import moment from 'moment'
import {
  clearAllNotificationMarksSessions,
  getManagerNotifMarkMap,
  mergeManagerNotifMarks,
  persistProfileNotificationMarksToSession
} from '@/utils/notificationMarks'
import getDefaultState from './defaultState'

export default {
  resetState(state) {
    clearAllNotificationMarksSessions()
    Object.assign(state, getDefaultState())
  },
  setTokens(state, { accessToken, refreshToken, firebaseToken }) {
    state.accessToken = accessToken
    state.refreshToken = refreshToken

    if (accessToken) {
      localStorage.setItem('blytzpay_access_token', accessToken)
    } else if (accessToken === null) {
      localStorage.removeItem('blytzpay_access_token')
    }

    if (refreshToken) {
      localStorage.setItem('blytzpay_refresh_token', refreshToken)
    } else if (refreshToken == null) {
      localStorage.removeItem('blytzpay_refresh_token')
    }

    // Only touch the firebase token when the caller provides the key, so
    // partial updates (e.g. a refresh that omits it) don't clear it.
    if (firebaseToken !== undefined) {
      state.firebaseToken = firebaseToken

      if (firebaseToken) {
        localStorage.setItem('blytzpay_firebase_token', firebaseToken)
      } else {
        localStorage.removeItem('blytzpay_firebase_token')
      }
    }
  },
  setLastActivity(state) {
    /*
     Sets the last activity as a utc unix timestamp
     This method should mostly be called from an axios interceptor
    */
    state.lastActivity = moment().utc().unix()
  },
  setIsInactive(state, isInactive) {
    state.isInactive = isInactive
  },
  setProfile(state, profile) {
    state.profile = profile
  },
  /**
   * Merge notification marks from clear-events (or similar) into profile.
   * Pass `{ patch, merchantId }` so marks are mirrored to sessionStorage for refresh
   * when GET profile does not yet return per-type / per-manager fields.
   */
  setProfileNotificationMarks(state, payload) {
    const patch =
      payload && typeof payload === 'object' && 'patch' in payload
        ? payload.patch
        : payload
    const merchantId =
      payload && typeof payload === 'object' && 'patch' in payload
        ? payload.merchantId
        : null

    if (!state.profile || !patch || typeof patch !== 'object') return
    const next = { ...state.profile }
    for (const [k, v] of Object.entries(patch)) {
      if (k === 'manager_notif_marks') {
        next[k] = mergeManagerNotifMarks(
          getManagerNotifMarkMap(state.profile),
          v
        )
      } else if (v !== undefined) {
        next[k] = v
      }
    }
    state.profile = next
    if (merchantId != null && next.id != null) {
      persistProfileNotificationMarksToSession(
        String(next.id),
        String(merchantId),
        next
      )
    }
  },
  setHeartbeat(state, heartbeat) {
    state.heartbeat = heartbeat
  }
}
